"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var service_1 = require("../service");
var signupFreeGuest = function (user) {
    return (0, service_1.getService)()
        .post('/signup_free_guest', { user: user })
        .then(function (_a) {
        var data = _a.data;
        return data;
    })
        .catch(function (_a) {
        var response = _a.response;
        return Promise.reject(response);
    });
};
exports.default = signupFreeGuest;
